// Widgetlar (features/widgets): yuqori panel, panel, soat, uz
export default {
  title: "Widgetlar",
  edit: "Tahrirlash",
  done: "Tayyor",
  add: "Widget qo'shish",
  addThis: "Qo'shish",
  back: "Orqaga",
  pin: "Yon tomonga qadash",
  unpin: "Qadashni yechish",
  empty: "Hali widget yo'q",
  emptyHint: "AQSh vaqtini bir qarashda ko'rish uchun dunyo soatlarini qo'shing.",
  full: "Ko'pi bilan {{n}} ta widget",
  removed: "{{name}} olib tashlandi",
  undo: "Qaytarish",
  removeWidget: "Widgetni olib tashlash",
  removeNamed: "{{name}} — olib tashlash",
  editWidget: "{{name}} — sozlash",
  showTop: "Yuqori panelda ko'rsatish",
  topFull: "ko'pi bilan {{n}} ta widget",
  sizeLabel: "O'lcham",
  size: { s: "Kichik", m: "O'rta", l: "Katta" },
  menu: {
    settings: "Sozlash",
    size: "O'lcham",
    showTop: "Yuqori panelda ko'rsatish",
    hideTop: "Yuqori paneldan olish",
    remove: "Olib tashlash",
  },
  failed: "Bu widgetni ko'rsatib bo'lmadi.",
  loadFailed: "Widgetlarni yuklab bo'lmadi.",
  retry: "Qayta urinish",
  conflict: "Widgetlar boshqa oynada o'zgartirildi. Eng yangisi ko'rsatildi.",
  saveFailed: "Widgetlarni saqlab bo'lmadi.",
  calendar: {
    title: "Kalendar",
    description: "Eslatmalar, ishga chiqish kunlari, carrier to'lov muddatlari va hujjat muddatlari bitta oy ko'rinishida.",
    glance_one: "Bugun {{count}} ta",
    glance_other: "Bugun {{count}} ta",
    today: "Bugun",
    tomorrow: "Ertaga",
    empty: "Yaqinda hech narsa yo'q",
    emptyDay: "Bu kunda hech narsa yo'q",
    prev: "Oldingi oy",
    next: "Keyingi oy",
    kindsTitle: "Ko'rsatish",
    showDone: "Bajarilgan eslatmalar ham",
    kinds: {
      reminder: "Eslatmalar",
      start: "Ishga chiqish / orientatsiya kuni",
      fee: "Carrier to'lov muddati",
      expiry: "Hujjat muddatlari",
      available: "Driver bo'sh bo'ladigan kun",
      assignment: "Biriktirish tugashi",
    },
  },
  callnow: {
    title: "Hozir qo'ng'iroq",
    description: "Mahalliy vaqti qo'ng'iroq oynasida bo'lgan driverlaringiz, eslatmasi kelganlar birinchi.",
    now: "hozir qo'ng'iroq qilsa bo'ladi",
    reminder: "eslatma",
    never: "hali gaplashilmagan",
    daysAgo_one: "{{count}} kun oldin",
    daysAgo_other: "{{count}} kun oldin",
    empty: "Hozir qo'ng'iroq qiladigan hech kim yo'q",
    callHint: "Driver shtatining mahalliy vaqti.",
    limit: "Ro'yxat uzunligi",
  },
  shift: {
    title: "Smena",
    description: "Smenangizda qolgan vaqt va AQSh zonalarida hozir ish vaqtimi.",
    left: "qoldi",
    ended: "tugadi",
    startsIn: "boshlanishiga",
    elapsed: "{{time}} o'tdi",
    usHours: "AQSh ish vaqti",
    start: "Boshlanish",
    end: "Tugash",
    hint: "O'z vaqt zonangizda ({{tz}}). Smena yarim tundan o'tishi mumkin.",
  },
  goal: {
    title: "Oylik maqsad",
    description: "Shu oy tasdiqlangan ishga olishlar maqsadga nisbatan, faollik halqasi kabi.",
    hires: "ishga olish",
    monthTitle: "Shu oy",
    remaining_one: "Maqsadgacha yana {{count}} ta",
    remaining_other: "Maqsadgacha yana {{count}} ta",
    ahead_one: "Sur'atdan {{count}} ta oldinda",
    ahead_other: "Sur'atdan {{count}} ta oldinda",
    behind_one: "Sur'atdan {{count}} ta orqada",
    behind_other: "Sur'atdan {{count}} ta orqada",
    onPace: "Sur'atda",
    day: "{{days}} kundan {{day}}-kun",
    bonus: "Har ishga olish {{amount}}",
    noGoal: "Maqsad belgilanmagan",
    noGoalOwner: "Maqsad: Sozlamalar → Bonus qoidasi",
  },
  starts: {
    title: "Yaqin orientatsiyalar",
    description: "Yaqin kunlarda ishga chiqadigan yoki orientatsiyadagi driverlar, mahalliy vaqti bilan.",
    within: "{{days}} kun ichida ishga chiqadi",
    empty: "Yaqin {{days}} kunda ishga chiqish yo'q",
    daysLabel: "Necha kun oldinga",
    days_one: "{{count}} kun",
    days_other: "{{count}} kun",
  },
  fees: {
    title: "Carrier to'lovlari",
    description: "Muddati o'tgan va yaqin carrier to'lovlari, qolgan summa bilan.",
    overdue_one: "{{count}} ta muddati o'tgan",
    overdue_other: "{{count}} ta muddati o'tgan",
    soon_one: "{{count}} ta {{days}} kun ichida",
    soon_other: "{{count}} ta {{days}} kun ichida",
    soonShort: "{{days}} kun ichida {{amount}} ({{count}} ta)",
    empty: "Muddati o'tgan yoki yaqin to'lov yo'q",
    daysLabel: "Muddat ichida",
  },
  note: {
    title: "Eslatma",
    description: "Qo'ng'iroq paytida tez yozib qo'yish. Serverda saqlanadi, har qurilmada ko'rinadi.",
    placeholder: "Eslatma yozing…",
    empty: "Bo'sh eslatma",
  },
  recent: {
    title: "Oxirgi ochilganlar",
    description: "Shu qurilmada oxirgi ochilgan driver va carrier'lar.",
    empty: "Hali hech narsa ochilmagan",
  },
  rate: {
    title: "Valyuta kursi",
    description: "Markaziy bank bo'yicha USD → UZS, oxirgi 30 kun bilan.",
    usd: "1 USD",
    week: "7 kun",
    cbu: "Markaziy bank",
    manual: "qo'lda kiritilgan",
    none: "Kurs hali yo'q",
    days_one: "{{count}} kun",
    days_other: "{{count}} kun",
  },
  clock: {
    title: "Dunyo soatlari",
    description: "AQSh vaqt zonalari va sizning vaqtingiz. Katta o'lchamda qo'ng'iroq qilsa bo'ladigan vaqt ko'rinadi.",
    day: { today: "Bugun", tomorrow: "Ertaga", yesterday: "Kecha" },
    hours: "{{value}} soat",
    now: "Hozir",
    callLegend: "Qo'ng'iroq vaqti {{from}}–{{to}}, mahalliy vaqt",
    zones: "Vaqt zonalari",
    reorder: "Sudrab tartiblash",
    label: "{{city}} uchun nom",
    removeZone: "{{city}} — olib tashlash",
    search: "Shahar yoki shtat (TX)",
    noResults: "Hech narsa topilmadi",
    addUs: "AQSh zonalari",
    maxZones: "Ko'pi bilan {{n}} ta vaqt zonasi.",
    seconds: "Soniya mili",
    format: "Vaqt formati",
    formatAuto: "Avto ({{value}} soatlik)",
    format24: "24 soatlik",
    format12: "12 soatlik",
    callHours: "Qo'ng'iroq vaqti",
    callFrom: "Boshlanishi",
    callTo: "Tugashi",
    callHint: "Har zonaning mahalliy vaqti; katta o'lchamda yashil bo'lib ko'rinadi.",
    cities: {
      "America/New_York": "Nyu-York",
      "America/Chicago": "Chikago",
      "America/Denver": "Denver",
      "America/Phoenix": "Feniks",
      "America/Los_Angeles": "Los-Anjeles",
      "America/Anchorage": "Ankorij",
      "Pacific/Honolulu": "Gonolulu",
      "Asia/Tashkent": "Toshkent",
      "Asia/Samarkand": "Samarqand",
      "Europe/Moscow": "Moskva",
      "Europe/London": "London",
      "Europe/Istanbul": "Istanbul",
      "Asia/Dubai": "Dubay",
      UTC: "UTC",
    },
  },
};
